import React, { useEffect } from "react";
import { routes } from "consts";
import { PageMain, AdminResourceDeleteModal } from "components/molecules";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  TanTableColumn,
  usePagination,
  useSorting,
} from "components/molecules";
import { useNavigate } from "react-router-dom";
import { useDeleteResourceActions } from "utils/store";
import { PageRichHeader } from "components/molecules/PageHeader/PageRichHeader";
import {
  ATTRIBUTE_TYPE_LABELS,
  CourseGroupAttributeApi,
  coursegroupAttributesApi,
} from "api/coursegroup-attributes";
import { useCourseGroupAttributes } from "api/coursegroup-attributes";

export const CourseGroupAttributesPage = () => {
  const { setDeleteResource } = useDeleteResourceActions();
  const { limit, onPaginationChange, skip, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const navigate = useNavigate();

  const { isFetching, isLoading, attributes, invalidate, total } = useCourseGroupAttributes(
    skip,
    limit,
    "",
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination]);

  const columns = React.useMemo<TanTableColumn<CourseGroupAttributeApi>[]>(
    () => [
      {
        id: "id",
        accessorKey: "id",
        header: "ID",
        size: 80,
        enableColumnFilter: false,
      },
      {
        id: "name",
        accessorKey: "name",
        header: "Nazwa",
        size: 400,
        enableColumnFilter: false,
      },
      {
        id: "attributeType",
        accessorKey: "attributeType",
        header: "Typ",
        enableColumnFilter: false,
        cell: (info) => ATTRIBUTE_TYPE_LABELS[info.getValue<number>()] ?? "-",
      },
    ],
    [],
  );

  return (
    <PageMain>
      <PageRichHeader header="Atrybuty grup kursów">
        <div className="flex grow justify-end gap-4">
          <PaziaButton
            type="secondary"
            title="Grupy kursów"
            onClick={() => navigate(routes.COURSE_GROUPS)}
          />
          <PaziaButton
            type="primary"
            title="Dodaj atrybut +"
            onClick={() => navigate(routes.COURSE_GROUPS_ATTRIBUTES_ADD)}
          />
        </div>
      </PageRichHeader>

      <TanTable
        data={attributes}
        columns={columns}
        total={total}
        loading={isLoading}
        fetching={isFetching}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        onRowClick={(r) => navigate(routes.COURSE_GROUPS_ATTRIBUTES_EDIT(r.id.toString()))}
        sorting={sorting}
        onDelete={(x) => setDeleteResource(x.id)}
      />
      <AdminResourceDeleteModal
        title="Usuń atrybut"
        description="Jesteś pewien że chcesz usunąć ten atrybut?"
        onSuccessDelete={invalidate}
        deleteAction={coursegroupAttributesApi.delete}
      />
    </PageMain>
  );
};
